/**
 * Action for show outdated view of a reservation.
 *
 * @class
 */
Sitepackage.Plugin.Reservation.ShowoutdatedAction = (function () {
    /**
     * Initializes the action.
     *
     * @param {Reservation} plugin Parent plugin
     * @param {Element} pluginContainer Parent plugin container
     * @param {Element} container Main container of the action
     *
     * @constructor
     */
    var ShowoutdatedAction = function (plugin, pluginContainer, container) {
        const self = this;

        // Parent plugin
        self.plugin = plugin;

        // Parent plugin container
        self.pluginContainer = pluginContainer;

        // Main container of the action
        self.container = container;

        var modalTitle = document.getElementById('modal-reservation-title');
        //Change headline of wizard from "new reservation" to "edit reservation"
        modalTitle.innerHTML = self.pluginContainer.dataset.edittitle;
        modalTitle.classList.remove('d-none');

        document.querySelectorAll('[data-toggle="tooltip"]').forEach(function (tooltip) {
            new Tooltip(tooltip);
        });

        //Remove loader HTML
        self.container.closest('.modal-body').querySelector('.loading-animation-container').remove();

        self.container.closest('.modal-content').querySelector('.modal-footer').classList.add('d-none');

    };


    return ShowoutdatedAction;
})();
